import React, { useEffect, useState } from "react";
import { getLoggedInUser } from "../utils/helper";
import { Link } from "react-router-dom/cjs/react-router-dom";

import logo from "../assets/img/humanely.png";

function Sidebar() {
    const TOKEN = localStorage.getItem("kloka:token:data");
    const [profile, setProfile] = useState('');

    useEffect(() => {
        if(TOKEN){
            getLoggedInUser(TOKEN).then((res) => { 
                if(res.data.success){
                    setProfile(res.data.data);  
                }
            }).catch((err) => { 
                console.log(err.response) 
            });
        }else {
            alert('Your session token has expired. Login again!')
        }
    }, [TOKEN]);

    const isOutsourced = profile
        ? profile &&
        profile.type && profile.type === "outsourced"
        : false;

    const isInHouse = profile
        ? profile &&
        profile.type && profile.type === "inhouse"
        : false;

    const isEmployee = profile
        ? profile &&
        profile.categories &&  profile.categories.includes("EMPLOYEE")
         : false;

    const isHRAdmin = profile
        ? profile &&
        profile.categories && profile.categories.includes("HR")
         : false;

    const isOutsourcing = profile
        ? profile &&
        profile.categories && profile.categories.includes("OUTSOURCING")
         : false;

    const isRecruitment = profile
        ? profile &&
        profile.categories && profile.categories.includes("RECRUITMENT")
         : false;

    const isSales = profile
        ? profile &&
        profile.categories && profile.categories.includes("SALES")
         : false;


    return (

        <div className={isOutsourced ? `dash-nav dash-nav-dark dash-nav-out` : `dash-nav dash-nav-dark` }>
            <header>
                <div className="menu-toggle"><i className="fa fa-bars"></i></div>
                <a href="/dashboard" className="dash-rank"> <img src={logo} width="130" alt="logo" />
                </a>
            </header>

            {(profile && isEmployee && isInHouse) && ( 
            <nav className="dash-nav-list hrcm">    
                <div className="dash-info">
                    <h3>{`${profile && profile.first_name} ${profile && profile.last_name}`}</h3>
                    <h3>{profile && profile.job_title?.name}</h3>
                    <h3>ID: 123456</h3>
                </div>

                <Link to="/dashboard" className="dash-nav-item"><i className="fa fa-dashboard"></i> Dashboard </Link>

                <div className="hrcm-dash-info"><h5>PROFILE</h5></div>
                <Link to="/profile" className="dash-nav-item"><i className="fa fa-user"></i> Profile </Link>
                <Link to="/attendance/records" className="dash-nav-item"><i className="fa fa-clock-o"></i> Attendance </Link>
                <Link to="/leave/requests" className="dash-nav-item"><i className="fa fa-table"></i> Leave Requests </Link>
                {/* <Link to="/loan" className="dash-nav-item"><i className="fa fa-money"></i> Loans </Link>
                <Link to="/assets" className="dash-nav-item"><i className="fa fa-briefcase"></i> Assets </Link>
                <Link to="/exit" className="dash-nav-item"><i className="fa fa-certificate"></i> Exit </Link> */}

                {isHRAdmin ? <>
                <div className="hrcm-dash-info"><h5>PEOPLE SERVICE</h5></div>
                <Link to="/employees" className="dash-nav-item"><i className="fa fa-users"></i> Employees </Link>
                <Link to="/hiring" className="dash-nav-item"><i className="fa fa-user-plus"></i> Hiring </Link>
                <Link to="/admin/roles" className="dash-nav-item"><i className="fa fa-user"></i> Assign Roles </Link>
                <Link to="/attendance/all" className="dash-nav-item"><i className="fa fa-clock-o"></i> All Attendance </Link>
                <Link to="/attendance/report" className="dash-nav-item"><i className="fa fa-calendar"></i> Attendance Report </Link>
                <Link to="/leave/tracker" className="dash-nav-item"><i className="fa fa-cc"></i> Leave Tracker </Link> 
                </> : null }

                {isOutsourcing ? <>
                <div className="hrcm-dash-info"><h5>OUTSOURCING</h5></div>
                <Link to="/outsourcing/organizations" className="dash-nav-item"><i className="fa fa-bar-chart"></i> Organizations</Link>
                <Link to="/outsourcing/employees" className="dash-nav-item"><i className="fa fa-clone"></i> Employees</Link>
                <Link to="/outsourcing/onboarding" className="dash-nav-item"><i className="fa fa-paper-plane"></i> Onboarding</Link>
                <Link to="/outsourcing/learning" className="dash-nav-item"><i className="fa fa-bookmark"></i> Learning</Link>
                <Link to="/outsourcing/leaves" className="dash-nav-item"><i className="fa fa-code-fork"></i> Leave</Link>
                </> : null }

                <div className="hrcm-dash-info"><h5>PERFORMANCE</h5></div>
                {/* <Link to="/performance/kpds" className="dash-nav-item"><i className="fa fa-database"></i> KPDs </Link> */}
                {/* <Link to="/performance/kpis" className="dash-nav-item"><i className="fa fa-database"></i> KPIs </Link> */}
                <Link to="/performance/tasks" className="dash-nav-item"><i className="fa fa-tags"></i> Daily Tasks </Link>
                <Link to="/performance/appraisals" className="dash-nav-item"><i className="fa fa-barcode"></i> Appraisals </Link>
                {/* <Link to="/performance/time-tracking" className="dash-nav-item"><i className="fa fa-clock-o"></i> Time Tracking </Link>
                <Link to="/performance/disciplinary" className="dash-nav-item"><i className="fa fa-balance-scale"></i> Disciplinary </Link> */}

                
                {/* <div className="hrcm-dash-info"><h5>COMPENSATION</h5></div>
                <Link to="/payroll" className="dash-nav-item"><i className="fa fa-bar-chart"></i> Payroll</Link>
                <Link to="/benefits" className="dash-nav-item"><i className="fa fa-cubes"></i> Benefits</Link> */}

                {isRecruitment ? <>
                <div className="hrcm-dash-info"><h5>RECRUITMENT</h5></div>
                <Link to="/recruitment/jobs" className="dash-nav-item"><i className="fa fa-code"></i> Job Openings</Link>
                {/* <Link to="/recruitment/talent-pool" className="dash-nav-item"><i className="fa fa-rocket"></i> Talent Pool</Link> */}
                </> : null}

                {isSales ? <>
                <div className="hrcm-dash-info"><h5>SALES</h5></div>
                <Link to="/sales" className="dash-nav-item"><i className="fa fa-money"></i> Sales</Link>
                </>: null}

                <div className="hrcm-dash-info"><h5>EXTRAS</h5></div>
                <Link to="#/" className="dash-nav-item"><i className="fa fa-question-circle"></i> Help</Link>
                <Link to="#/" className="dash-nav-item"><i className="fa fa-support"></i> Support</Link>
                <Link to="#/" className="dash-nav-item"><i className="fa fa-cog"></i> Settings </Link>

            </nav> 
            )}
        </div>
    );
}

export default Sidebar;
